import { PauseCircleOutlined } from '@ant-design/icons';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { isButtonActionExecAsyncService } from './actions/IButtonAction.ts';
import { ButtonWidgetComponent } from './ButtonWidgetComponent.tsx';
import {
  ButtonWidgetConfigComponent,
  ButtonWidgetConfigSchema,
} from './ButtonWidgetConfigComponent.tsx';
import { createButtonWidgetSchema } from './createButtonWidgetSchema.ts';
import { getButtonWidgetSiblingReferences } from './getButtonWidgetSiblingReferences.ts';
import { type IButtonWidget } from './IButtonWidget.ts';

export const ButtonWidgetType: IWidgetType<IButtonWidget> = {
  type: WidgetType.Button,
  mainType: WidgetMainType.Base,
  category: WidgetCategory.Advanced,
  name: 'Pulsante',
  icon: <PauseCircleOutlined />,
  hasValue: false,
  getReference: (path, widget) => {
    // Genero una reference soltanto se il pulsante esegue un servizio asincrono
    if (widget.actions?.filter(isButtonActionExecAsyncService).length) {
      return getSimpleWidgetReference(Datatype.Hidden)(path, widget);
    }
    return null;
  },
  getSiblingReferences: getButtonWidgetSiblingReferences,
  formComponent: ButtonWidgetComponent,
  createFormSchema: createButtonWidgetSchema,
  previewComponent: ButtonWidgetComponent,
  configValidator: ButtonWidgetConfigSchema,
  configComponent: ButtonWidgetConfigComponent,
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
    actions: tran.array(
      tran.object({
        requestMessage: tran.rte(),
        successMessage: tran.rte(),
      }),
    ),
  }),
  rules: [],
  aliases: ['bottone', 'azione'],
};
